import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { showToast } from 'hoi-poi-ui';
export default {
  required: 'cfm_label_field_required'
};
const defaultErrorToastProps = {
  type: 'error',
  transition: 'slide',
  position: 'bottomLeft',
  useDefaultCloseButton: true,
  autoClose: 4000
};
export const showErrorToast = function (t, error, literalCustom, entity) {
  var _error$response, _error$response$data, _error$response2, _error$response2$data, _error$response3, _error$response3$data, _error$response5, _error$response5$data, _error$response7, _error$response7$data, _error$response8, _error$response8$data, _error$response9, _error$response9$data;
  if (literalCustom === void 0) {
    literalCustom = 'cfm_label_error_generic';
  }
  if (entity === void 0) {
    entity = null;
  }
  const message = (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || (error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.error);
  const entitiesLiterals = {
    Empresas: t('cfm_label_accounts'),
    Contactos: t('cfm_label_contacts'),
    Expedientes: t('cfm_label_opportunities'),
    Gestiones: t('cfm_label_activities'),
    tblAgenda: t('cfm_label_event_task'),
    tblSalesOrders: t('cfm_label_salesorders'),
    Productos: t('cfm_label_products'),
    tblUsuarios: t('cfm_label_users')
  };
  if ((error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : _error$response3$data.code) === 931) {
    var _error$response4, _error$response4$data;
    const LANG_NAMES = {
      ES: t('cfm_label_spanish'),
      EN: t('cfm_label_en_uk'),
      US: t('cfm_label_en_us'),
      FR: t('cfm_label_fr'),
      IT: t('cfm_label_it'),
      DE: t('cfm_label_de'),
      PT: t('cfm_label_pt'),
      RU: t('cfm_label_ru'),
      DK: t('cfm_label_da'),
      BR: t('cfm_label_pt_br')
    };
    const keys = error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : _error$response4$data.message.split(',').map(el => LANG_NAMES[el]);
    showToast(_objectSpread(_objectSpread({}, defaultErrorToastProps), {}, {
      title: t('cfm_label_error_action_with_message'),
      text: t('cfm_error_duplicated_field_name', [entitiesLiterals[entity], keys.join(', ')])
    }));
  } else if ((error === null || error === void 0 ? void 0 : (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : (_error$response5$data = _error$response5.data) === null || _error$response5$data === void 0 ? void 0 : _error$response5$data.code) === 807) {
    var _error$response6, _error$response6$data;
    let trimmedStr = error === null || error === void 0 ? void 0 : (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : (_error$response6$data = _error$response6.data) === null || _error$response6$data === void 0 ? void 0 : _error$response6$data.message.slice(1, -1); // Removes the brackets
    let entities = trimmedStr.split(', ').map(item => item.trim());
    const replaceables = entities.reduce((arr, current) => {
      if (entitiesLiterals !== null && entitiesLiterals !== void 0 && entitiesLiterals[current]) arr.push(entitiesLiterals[current]);
      return arr;
    }, []);
    showToast(_objectSpread(_objectSpread({}, defaultErrorToastProps), {}, {
      title: t('cfm_label_error_action_with_message'),
      text: t('error_table_has_dependent_fields', replaceables)
    }));
  } else if ((error === null || error === void 0 ? void 0 : (_error$response7 = error.response) === null || _error$response7 === void 0 ? void 0 : (_error$response7$data = _error$response7.data) === null || _error$response7$data === void 0 ? void 0 : _error$response7$data.code) === 803) {
    showToast(_objectSpread(_objectSpread({}, defaultErrorToastProps), {}, {
      title: t('cfm_label_error_action_with_message'),
      text: t(message)
    }));
  } else if ((error === null || error === void 0 ? void 0 : (_error$response8 = error.response) === null || _error$response8 === void 0 ? void 0 : (_error$response8$data = _error$response8.data) === null || _error$response8$data === void 0 ? void 0 : _error$response8$data.code) !== 901 && message) {
    showToast({
      title: t('cfm_label_error_action_with_message'),
      text: t(message)
    });
  } else if ((error === null || error === void 0 ? void 0 : (_error$response9 = error.response) === null || _error$response9 === void 0 ? void 0 : (_error$response9$data = _error$response9.data) === null || _error$response9$data === void 0 ? void 0 : _error$response9$data.code) !== 901 && !message) {
    showToast({
      title: t('cfm_label_error_action_with_message'),
      text: error.toString()
    });
  } else {
    showToast({
      title: t(literalCustom)
    });
  }
};